import React, { useEffect, useState } from 'react';
import { Report } from './Report';

import api from '../api';


export const Results = ({ key, token, activeJobs, alert, onChange }) => {
  if (activeJobs === []) {
    return <pre>Loading...</pre>
  }

  return (
    <div className="accordion" id="accordion" style={{accordionBg: `var(--bs-danger)`}}>
      {activeJobs.map((job, i) => <Report key={i} token={token} jobInfo={job} alert={alert} first={i === 0}/>)}
    </div>
  )
};

